import React, { useEffect, useState } from "react";

import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { TextField, Box, Dialog } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import styles from "./meetings.module.scss";
import Images from "assets/Images";
import ScheduleMeeting from "./scheduleMeeting";
import TranscriptPage from "./transcriptModal";
import FormDialog from "components/minor/dialog/form-dialog";

const Transcripts = () => {
    const [value, setValue] = React.useState([dayjs(), dayjs().add(7, 'day')]);

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div className={styles.ScheduledMeetingList}>
            <div className={styles.upcomingMeetings}>
                <span className={styles.headerRecordings}>
                    <h3>Transcripts</h3>
                        <FormDialog open={open} handleClose={handleClose} title="Transcript">
                            <TranscriptPage />
                        </FormDialog>
                    <div className={`${styles.dateRange} customDateRangePicker`}>
                    
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateRangePicker
                                value={value}
                                onChange={(newValue) => setValue(newValue)}
                                   PopperProps={{
                                        modifiers: [
                                        {
                                            name: "preventOverflow",
                                            options: {
                                            boundary: "viewport", 
                                            padding: 8,
                                            },
                                        },
                                        {
                                            name: "flip",
                                            options: {
                                            fallbackPlacements: ["bottom-end", "top-end"], 
                                            },
                                        },
                                        ],
                                    }}
                                renderInput={(startProps, endProps) => (
                                    <Box sx={{ display: 'flex', gap: 2,right:10 }}>
                                        <TextField {...startProps} label="Start date" />
                                        <TextField {...endProps} label="End date" />
                                    </Box>
                                )}
                            />
                        </LocalizationProvider>
                        <img src={Images.CALENDAR} width="16" className="calenderIcon" />
                    </div>
                </span>
                <section className={styles.meetingList}>
                    <div className={styles.meetingGroup}>
                        <label>Mon, Jan 20</label>
                        <ul>
                            <li>
                                <table  >
                                    <tbody>
                                        <tr>
                                            <td><h5>06:30 PM - 07:10 PM</h5></td>
                                            <td>
                                                <h4>Steering Committe Meeting - N7 & GTM U...</h4>
                                                <p>Meeting ID : 818 1986 0368</p>
                                            </td>
                                            <td>
                                                <ul className={styles.actionIcons}>
                                                    <li>
                                                        <button
                                                            onClick={handleClickOpen}
                                                            className={styles.btnPrimary}
                                                        >
                                                            View Transcript
                                                        </button>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </li>
                        </ul>
                    </div>

                    <div className={styles.meetingGroup}>
                        <label>Mon, Jan 20</label>
                        <ul>
                            <li>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><h5>06:30 PM - 07:10 PM</h5></td>
                                            <td>
                                                <h4>Steering Committe Meeting - N7 & GTM U...</h4>
                                                <p>Meeting ID : 818 1986 0368</p>
                                            </td>
                                            <td>
                                                <ul className={styles.actionIcons}>
                                                    <li>
                                                        <button
                                                        onClick={handleClickOpen}
                                                            className={styles.btnPrimary}
                                                        >
                                                            View Transcript
                                                        </button>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </li>
                        </ul>
                    </div>
                </section>

            </div>
        </div>
    );
};

export default Transcripts;
